module.exports = __webpack_public_path__ + "assets/img/create-team-btn-c26d7835.png";